<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :pick-up-location="pickUpLocation"
        :drop-off-location="dropOffLocation"
        :form-component="formComponent"
        show-passengers
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import CarsSearchForm from '~src/components/carsRent/search/forms/CarsSearchForm.vue'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            CarsSearchForm,
        },
    })
    export class CarsSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest
        @Prop({default: false, type: Boolean}) showPassengers

        searchForm = false

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get isSearchActive() {
            return carsRentRuntimeStore.searchActive
        }

        get locationLabel() {
            const pickUpPointLabel = `${carsRentRuntimeStore.pickUpPoint.name}, ${carsRentRuntimeStore.pickUpPoint.parentName}`
            const dropOffPointLabel = `${carsRentRuntimeStore.dropOffPoint.name}, ${carsRentRuntimeStore.dropOffPoint.parentName}`

            return pickUpPointLabel === dropOffPointLabel
                ? pickUpPointLabel
                : `${pickUpPointLabel} - ${dropOffPointLabel}`
        }

        get pickUpLocation() {
            return carsRentStore.pickUpLocation
        }

        get dropOffLocation() {
            return carsRentStore.dropOffLocation
        }

        get formComponent() {
            return resolveComponent('CarsSearchForm')
        }
    }

    export default CarsSearchSummary
</script>
